import { useEffect, useState } from 'react'

export function useSecondaryFormContainer({
  isMobile,
  activeOtherSection,
  containerRef,
}) {
  const [secondaryFormContainerHeight, setSecondaryFormContainerHeight] =
    useState('calc(100vh - 240px)')

  useEffect(() => {
    if (!isMobile && activeOtherSection) {
      const handleScroll = () => {
        if (containerRef.current) {
          const rect = containerRef.current.getBoundingClientRect()
          const distanceToTop = rect.top - window.scrollY // distance from top of page
          if (distanceToTop < 75) {
            setSecondaryFormContainerHeight('calc(100vh - 173px)')
          } else {
            setSecondaryFormContainerHeight('calc(100vh - 240px)')
          }
        }
      }

      window.addEventListener('scroll', handleScroll)
      handleScroll()

      return () => {
        window.removeEventListener('scroll', handleScroll)
      }
    }
  }, [isMobile, activeOtherSection])

  return {
    secondaryFormContainerHeight,
  }
}
